export const MARKET_TIMEZONE = 'America/New_York';
export const API_DATE_WITH_TIME_AND_TIMEZONE = 'MM/dd/yyyy HH:mm:ss z';
export const API_DATE_YEAR_FIRST = 'yyyy-MM-dd';
export const API_DATE = 'MM/dd/yyyy';
